import { PluginCreator } from "tailwindcss/types/config"

const sharedButtonStyles = {
  borderRadius: "100px",
  borderWidth: "1px",
  transition: "background-color 250ms ease-in-out, border-color 250ms ease-in-out, color 250ms ease-in-out",
}

const sharedWithoutBorder = {
  ...sharedButtonStyles,
  borderWidth: "0",
}

const buttonPlugin: PluginCreator = ({ addUtilities, theme }) => {
  const newUtilities = {
    ".button-pro-gradient": {
      color: theme("colors.fg.1") as string,
      ...sharedWithoutBorder,
    },
    ".button-pro-gradient:hover": {
      color: theme("colors.fg.1") as string,
      ...sharedWithoutBorder,
    },
    ".button-pro-gradient:disabled, .button-pro-gradient:hover:disabled": {
      color: theme("colors.fg.1") as string,
      ...sharedWithoutBorder,
    },
    ".button-pro-primary": {
      backgroundColor: theme("colors.fg.1") as string,
      borderColor: theme("colors.fg.1") as string,
      color: theme("colors.fg.inverse") as string,
      ...sharedButtonStyles,
    },
    ".button-pro-primary:hover": {
      backgroundColor: theme("colors.fg.1") as string,
      borderColor: theme("colors.fg.1") as string,
      color: theme("colors.fg.inverse") as string,
      ...sharedButtonStyles,
    },
    ".button-pro-primary:disabled, .button-pro-primary:hover:disabled": {
      backgroundColor: theme("colors.fg.1") as string,
      borderColor: theme("colors.fg.1") as string,
      color: theme("colors.fg.inverse") as string,
      ...sharedButtonStyles,
    },
    ".button-primary": {
      backgroundColor: theme("colors.bg.7") as string,
      borderColor: theme("colors.bg.7") as string,
      color: theme("colors.fg.inverse") as string,
      ...sharedButtonStyles,
    },
    ".button-primary:hover": {
      backgroundColor: theme("colors.primary.6") as string,
      borderColor: theme("colors.primary.6") as string,
      color: theme("colors.fg.inverse") as string,
      ...sharedButtonStyles,
    },
    ".button-primary:disabled, .button-primary:hover:disabled": {
      backgroundColor: theme("colors.fg.4") as string,
      borderColor: theme("colors.fg.4") as string,
      color: theme("colors.bg.1") as string,
      ...sharedButtonStyles,
    },
    ".button-secondary": {
      backgroundColor: theme("colors.primary.1") as string,
      borderColor: theme("colors.primary.1") as string,
      color: theme("colors.primary.6") as string,
      ...sharedButtonStyles,
    },
    ".button-secondary:hover": {
      backgroundColor: theme("colors.primary.2") as string,
      borderColor: theme("colors.primary.2") as string,
      color: theme("colors.primary.6") as string,
      ...sharedButtonStyles,
    },
    ".button-tertiary": {
      backgroundColor: theme("colors.bg.1") as string,
      borderColor: theme("colors.primary.2") as string,
      color: theme("colors.fg.1") as string,
      ...sharedButtonStyles,
    },
    ".button-tertiary:hover": {
      backgroundColor: theme("colors.bg.1") as string,
      borderColor: theme("colors.primary.4") as string,
      color: theme("colors.fg.1") as string,
      ...sharedButtonStyles,
    },
    ".button-transparent": {
      backgroundColor: "transparent",
      borderColor: "transparent",
      color: theme("colors.fg.1") as string,
      ...sharedButtonStyles,
    },
    ".button-transparent:hover": {
      backgroundColor: theme("colors.bg.2") as string,
      borderColor: theme("colors.bg.2") as string,
      color: theme("colors.fg.1") as string,
      ...sharedButtonStyles,
    },
    ".button-error": {
      backgroundColor: theme("colors.red.dark") as string,
      borderColor: theme("colors.red.dark") as string,
      color: theme("colors.bg.1") as string,
      ...sharedButtonStyles,
    },
    ".button-error:hover": {
      backgroundColor: theme("colors.red.default") as string,
      borderColor: theme("colors.red.default") as string,
      color: theme("colors.bg.1") as string,
      ...sharedButtonStyles,
    },
    ".button-error-outline": {
      backgroundColor: "transparent" as string,
      borderColor: theme("colors.red.light") as string,
      color: theme("colors.red.dark") as string,
      ...sharedButtonStyles,
    },
    ".button-error-outline:hover": {
      backgroundColor: "transparent" as string,
      borderColor: theme("colors.red.dark") as string,
      color: theme("colors.red.dark") as string,
      ...sharedButtonStyles,
    },
    ".button-white": {
      backgroundColor: theme("colors.bg.1") as string,
      borderColor: theme("colors.bg.1") as string,
      color: theme("colors.fg.1") as string,
      ...sharedButtonStyles,
    },
    ".button-white:hover": {
      backgroundColor: theme("colors.bg.2") as string,
      borderColor: theme("colors.bg.2") as string,
      color: theme("colors.fg.1") as string,
      ...sharedButtonStyles,
    },
    ".button-grey-fill": {
      backgroundColor: theme("colors.bg.2") as string,
      borderColor: theme("colors.bg.2") as string,
      color: theme("colors.fg.1") as string,
      ...sharedButtonStyles,
    },
    ".button-grey-fill:hover": {
      backgroundColor: theme("colors.bg.3") as string,
      borderColor: theme("colors.bg.3") as string,
      color: theme("colors.fg.1") as string,
      ...sharedButtonStyles,
    },
    ".button-grey-fill-active": {
      backgroundColor: theme("colors.bg.7") as string,
      borderColor: theme("colors.bg.7") as string,
      color: theme("colors.fg.1") as string,
      ...sharedButtonStyles,
    },
    ".button-grey-outline": {
      backgroundColor: theme("colors.bg.1") as string,
      borderColor: theme("colors.bg.3") as string,
      color: theme("colors.fg.1") as string,
      ...sharedButtonStyles,
    },
    ".button-grey-outline:hover": {
      backgroundColor: theme("colors.bg.2") as string,
      borderColor: theme("colors.bg.3") as string,
      color: theme("colors.fg.1") as string,
      ...sharedButtonStyles,
    },
    ".button-grey-dark": {
      backgroundColor: theme("colors.bg.3") as string,
      borderColor: theme("colors.bg.3") as string,
      color: theme("colors.fg.1") as string,
      ...sharedButtonStyles,
    },
    ".button-grey-dark:hover": {
      backgroundColor: theme("colors.bg.4") as string,
      borderColor: theme("colors.bg.4") as string,
      color: theme("colors.fg.1") as string,
      ...sharedButtonStyles,
    },
  }

  addUtilities(newUtilities)
}

export default buttonPlugin
